/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import { useState, useLayoutEffect, useEffect, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { node, func, oneOfType } from 'prop-types';
import setRef from '../../utils/headerUtils';
import HTMLElementType from '../../utils/HTMLElementType';

const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const getContainer = (container) => {
  return typeof container === 'function' ? container() : container;
};

const Portal = forwardRef(({ children = null, container = null }, ref) => {

  const [mountNode, setMountNode] = useState(null);

  useEnhancedEffect(() => {
    setMountNode(getContainer(container) || document.body);
  }, [container]);

  useEnhancedEffect(() => {
    if (mountNode) {
      setRef(ref, mountNode);
      return () => {
        setRef(ref, null);
      };
    }
    return undefined;
  }, [ref, mountNode]);

  return mountNode ? createPortal(children, mountNode) : mountNode;
});

Portal.displayName = 'Portal';

Portal.propTypes = {
  children: node,
  container: oneOfType([
    HTMLElementType,
    func,
  ]),
};

export { Portal };
